"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPriceAlpha = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const andes_react_1 = require("@yonderland/andes-react");
const ProductSelector_1 = require("../../../redux/product/selectors/ProductSelector");
const usePriceProps_1 = require("../../../hooks/usePriceProps");
const ProductPriceAlpha = () => {
    var _a;
    const priceInformation = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetPriceInformation)());
    const dynamicSavingsInformation = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetDynamicSavingsInformation)());
    const priceProps = (0, usePriceProps_1.usePriceProps)({
        priceInformation: {
            prices: (priceInformation || {}).prices,
            hasDiscount: Boolean(priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.hasDiscount),
        },
        dynamicSavingsInformation,
        enablePriceReference: true,
    });
    return ((_a = priceInformation === null || priceInformation === void 0 ? void 0 : priceInformation.prices) === null || _a === void 0 ? void 0 : _a.SELL) && !!priceProps ? ((0, jsx_runtime_1.jsx)(andes_react_1.Price, Object.assign({ testId: "product_price", size: "lg" }, priceProps))) : null;
};
exports.ProductPriceAlpha = ProductPriceAlpha;
